export default __webpack_public_path__ + "static/media/support.513a99f0.svg";